// Configuration for the generic content management page.
// Each content type has its own field schema and seed data.
import {
  ANNOUNCEMENTS, PROGRAMS, PROJECTS, MONTHLY_ACCOMPLISHMENTS, OFFICIALS,
} from './mockData';

export const CONTENT_TYPES = {
  announcements: {
    label: 'Announcements',
    singular: 'Announcement',
    storageKey: 'cms_announcements',
    seed: ANNOUNCEMENTS,
    fields: [
      { name: 'title', label: 'Title', type: 'text', required: true, full: true },
      { name: 'category', label: 'Category', type: 'text', required: true },
      { name: 'date', label: 'Date', type: 'date', required: true },
      { name: 'pinned', label: 'Pinned to top', type: 'switch' },
      { name: 'image', label: 'Image URL (optional)', type: 'text', full: true, placeholder: 'https://...' },
      { name: 'summary', label: 'Summary', type: 'textarea', required: true, rows: 2, full: true },
      { name: 'content', label: 'Full Content', type: 'textarea', rows: 5, full: true, required: true },
    ],
    columns: ['title', 'category', 'date', 'pinned'],
    titleField: 'title',
  },
  programs: {
    label: 'Programs & Events',
    singular: 'Program',
    storageKey: 'cms_programs',
    seed: PROGRAMS,
    fields: [
      { name: 'title', label: 'Program Title', type: 'text', required: true, full: true },
      { name: 'category', label: 'Category', type: 'text', required: true },
      { name: 'date', label: 'Date', type: 'date', required: true },
      { name: 'time', label: 'Time', type: 'text', placeholder: '8:00 AM – 4:00 PM' },
      { name: 'location', label: 'Location', type: 'text', required: true },
      { name: 'slots', label: 'Total Slots', type: 'number' },
      { name: 'registered', label: 'Already Registered', type: 'number' },
      { name: 'image', label: 'Image URL', type: 'text', full: true, placeholder: 'https://...' },
      { name: 'description', label: 'Description', type: 'textarea', rows: 3, full: true, required: true },
      { name: 'requirements', label: 'Requirements', type: 'textarea', rows: 2, full: true },
      { name: 'contact', label: 'Contact', type: 'text', full: true },
    ],
    columns: ['title', 'category', 'date', 'location'],
    titleField: 'title',
  },
  projects: {
    label: 'Projects',
    singular: 'Project',
    storageKey: 'cms_projects',
    seed: PROJECTS,
    fields: [
      { name: 'name', label: 'Project Name', type: 'text', required: true, full: true },
      { name: 'category', label: 'Category', type: 'text', required: true },
      { name: 'status', label: 'Status', type: 'select', options: ['Planned', 'Ongoing', 'Completed'], required: true },
      { name: 'location', label: 'Location', type: 'text', required: true },
      { name: 'startDate', label: 'Start Date', type: 'date' },
      { name: 'completedDate', label: 'Completed Date', type: 'date' },
      { name: 'targetDate', label: 'Target Date', type: 'date' },
      { name: 'beneficiaries', label: 'Beneficiaries', type: 'text', full: true },
      { name: 'image', label: 'Image URL', type: 'text', full: true, placeholder: 'https://...' },
      { name: 'description', label: 'Description', type: 'textarea', rows: 3, full: true, required: true },
    ],
    columns: ['name', 'category', 'status', 'location'],
    titleField: 'name',
  },
  accomplishments: {
    label: 'Monthly Accomplishments',
    singular: 'Accomplishment',
    storageKey: 'cms_accomplishments',
    seed: MONTHLY_ACCOMPLISHMENTS,
    fields: [
      { name: 'month', label: 'Month / Period', type: 'text', required: true, placeholder: 'e.g., December 2026' },
      { name: 'image', label: 'Image URL', type: 'text', placeholder: 'https://...' },
      { name: 'summary', label: 'Summary', type: 'textarea', rows: 3, full: true, required: true },
    ],
    columns: ['month', 'summary'],
    titleField: 'month',
  },
  officials: {
    label: 'Officials',
    singular: 'Official',
    storageKey: 'cms_officials',
    seed: OFFICIALS,
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true, full: true },
      { name: 'position', label: 'Position', type: 'text', required: true },
      { name: 'committee', label: 'Committee', type: 'text', required: true },
      { name: 'photo', label: 'Photo URL', type: 'text', full: true, placeholder: 'https://...' },
    ],
    columns: ['name', 'position', 'committee'],
    titleField: 'name',
  },
};
